import fontStacks from './fontStacks';

const captionStyles = Object.freeze({
  marginTop: 0,
  fontFamily: fontStacks.default,
  fontWeight: '700',
  captionColor: [ 'neutral', '-2', ],
  backgroundColor: [ 'neutral', '-10', ],
  captionTypeSettings: -2,
  creditStyles: Object.freeze({
    fontWeight: '400',
  }),
});

export default captionStyles;
